"use client";

function normalizeTrend(trend) {
  if (trend === "up") return "increased";
  if (trend === "down") return "decreased";
  return trend ?? "unchanged";
}

function getValueTrendClass(normalizedTrend) {
  if (normalizedTrend === "increased") return "kbv-odds-value--up";
  if (normalizedTrend === "decreased") return "kbv-odds-value--down";
  return "";
}


export default function OddsMatchCell({ label, value, trend = "unchanged" }) {
  const hasLabel = label != null && label !== "";
  const display = value != null && value !== "" ? value : "-";
  const normalizedTrend = normalizeTrend(trend);
  const trendClass = getValueTrendClass(normalizedTrend);
  const hasArrow = normalizedTrend === "increased" || normalizedTrend === "decreased";
  const normalCellClass = !hasArrow ? "kbv-odds-cell--normal" : "";

  return (
    <div className={`kbv-odds-cell flex items-center p-0 h-5 leading-5 text-xs cursor-pointer relative rounded-sm ${normalCellClass} ${trendClass}`}>
      {hasLabel && (
        <span className="text-xs font-normal whitespace-nowrap shrink-0 px-0.5 text-[color:var(--kbv-odds-label-color)]">
          {label}
        </span>
      )}
      <span
        className={`ml-auto inline-flex items-center justify-end relative font-bold text-xs whitespace-nowrap pl-0.5 pr-3.5 rounded-[3px] transition-colors text-[color:var(--kbv-odds-value-color)] w-[34px] ${trendClass}`}
      >
        <strong>{display}</strong>
      </span>
    </div>
  );
}
